// Calcul pur des nouvelles valeurs de listes pour les mises à jour optimistes du chat IA.
import type { TokenUsage, AiConversationInfo, AiMessageInfo } from './types'

export function sumTokenUsage(
  current: TokenUsage,
  added: TokenUsage
): TokenUsage {
  return {
    inputTokens: current.inputTokens + added.inputTokens,
    outputTokens: current.outputTokens + added.outputTokens,
    totalTokens: current.totalTokens + added.totalTokens,
    cost: (current.cost ?? 0) + (added.cost ?? 0)
  }
}

// Dédoublonne par id : une conversation a pu remonter en tête entre deux pages du scroll infini.
export function appendNewConversations(
  loaded: AiConversationInfo[],
  fetched: AiConversationInfo[]
): AiConversationInfo[] {
  const alreadyLoaded = new Set(loaded.map(c => c.id))
  return [...loaded, ...fetched.filter(c => !alreadyLoaded.has(c.id))]
}

export function moveConversationToFront(
  conversations: AiConversationInfo[],
  id: string,
  updatedAt: string
): AiConversationInfo[] {
  const index = conversations.findIndex(c => c.id === id)
  if (index === -1) return conversations
  const moved = { ...conversations[index], updated_at: updatedAt }
  return [
    moved,
    ...conversations.slice(0, index),
    ...conversations.slice(index + 1)
  ]
}

// Sépare les messages autour de `id` (inclus dans `kept`) : réédition/relance jette les réponses suivantes.
export function splitMessagesAtId(
  messages: AiMessageInfo[],
  id: string
): { kept: AiMessageInfo[]; removed: AiMessageInfo[] } {
  const index = messages.findIndex(m => m.id === id)
  if (index === -1) return { kept: messages, removed: [] }
  return {
    kept: messages.slice(0, index + 1),
    removed: messages.slice(index + 1)
  }
}
